import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=2be9c502&scoped=true"
import script from "./Intro.vue?vue&type=script&lang=ts"
export * from "./Intro.vue?vue&type=script&lang=ts"
import style0 from "./Intro.vue?vue&type=style&index=0&id=2be9c502&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9c502",
  null
  
)

export default component.exports